import { IIntelliUploadInitiateRuleEngineRequest, IIntelliUploadInitiateRuleEngineResponse } from "@/core/repositories/intelli-upload";
import { IntelliUploadRepository } from "@/infrastructure/repositories/intelli-upload";

export class InitiateRuleEngineUseCase {
  constructor(private readonly intelliUploadRepository: IntelliUploadRepository) {}

  async execute(request: IIntelliUploadInitiateRuleEngineRequest): Promise<IIntelliUploadInitiateRuleEngineResponse> {
    return this.intelliUploadRepository.initiateRuleEngine(request);
  }
}
